var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000.01 1000.01",
    style: {
      enableBackground: "new 0 0 1000.01 1000.01"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8278F9;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M587.68,329.52c-2.57,68.23-5.15,136.46-7.72,204.69c-22.25,26.05-56.82,61.8-105.49,95.79 c-56.25,39.28-112.87,78.81-192.75,82.15c-17.77,0.74-133.54,3.35-212.99-87.53C29.32,579.56,7,519.09,7,448 c0-46.32,11.42-88.47,31.37-124.66C83.99,240.6,177.6,189.97,271.15,190.19c73.68,0.18,128.39,32.03,153.75,49.45 c-24.55,40.38-49.09,80.77-73.64,121.15c-6.82-5.91-33.99-28.06-74.83-27.96c-8.42,0.02-47.5,0.89-78.39,31.89 c-19.83,19.9-32.55,48.56-32.55,84.34c0,75.02,52.83,120.45,116.22,120.45c29.43,0,52.88-10.89,71.34-21.83 C443.61,494.01,570.97,348.72,587.68,329.52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M613.03,83.9v284.98c31-41,84.99-69,144.99-69c125.99,0,229.98,97.99,229.98,248.98 S886.01,793.85,753.02,793.85c-63,0-113.99-24-144.99-65v55H463.04V83.9H613.03z M838.01,548.86c0-79.99-50-123.99-114.99-123.99 c-65,0-114.99,44-114.99,123.99c0,75.99,51,119.99,114.99,119.99S838.01,624.86,838.01,548.86z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCb);
export default __webpack_public_path__ + "static/media/cb.8d6df425.svg";
export { ForwardRef as ReactComponent };